// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"toCategoryButtons_dropdownMenu__xhUsr","triggerButton":"toCategoryButtons_triggerButton__guf80","customTrigger":"toCategoryButtons_customTrigger__bvj0Q"};